const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_744",
  "data-name": "Rectangle 744",
  width: 26.154,
  height: 27.616,
  fill: "#008941"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2704",
  "data-name": "Group 2704",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2402",
  "data-name": "Path 2402",
  d: "M17.022,55.354c-2.7-3.965-6.295-6.072-8.18-4.781a2.171,2.171,0,0,0-.533.536c0,.015-4.364,8.847-4.364,8.847L1.509,61.606A3.441,3.441,0,0,0,.6,66.387l.11.161a3.447,3.447,0,0,0,4.76.914l3.913,5.765a2.221,2.221,0,0,0,3.045.585,2.063,2.063,0,0,0,.914-1.4A2.18,2.18,0,0,0,13,70.766L9.551,65.68s8.149-.649,8.18-.661a1.948,1.948,0,0,0,.71-.3c.968-.658,1.316-2.037.981-3.886a14.9,14.9,0,0,0-2.4-5.475M1.591,65.948l-.11-.161a2.372,2.372,0,0,1,.633-3.3l2.1-1.431L7,65.147l-2.1,1.431a2.375,2.375,0,0,1-3.3-.63m10.531,5.418a1.127,1.127,0,0,1-1.87,1.258l-3.9-5.747,1.568-1.066.414-.034ZM8,64.733,4.978,60.275l2.887-5.887a14.65,14.65,0,0,0,2.409,5.546,14.7,14.7,0,0,0,4.264,4.285Zm8.984-.71c-1.455-.094-3.825-1.736-5.832-4.693S8.5,53.575,8.945,52.183a1.3,1.3,0,0,1,1.218-.914c1.443,0,3.9,1.651,5.966,4.693a12.991,12.991,0,0,1,2.241,5.067c.454,2.994-1.383,2.994-1.383,2.994",
  transform: "translate(0 -46.571)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2403",
  "data-name": "Path 2403",
  d: "M152.27,122.572a2.859,2.859,0,0,0-2.168.448.535.535,0,0,0,.609.88,1.827,1.827,0,0,1,2.052,3.024.533.533,0,0,0,.3.972.521.521,0,0,0,.3-.092,2.89,2.89,0,0,0-1.081-5.232Z",
  transform: "translate(-139.055 -113.677)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2404",
  "data-name": "Path 2404",
  d: "M238.828,5.077h.052a.533.533,0,0,0,.53-.478l.411-4a.533.533,0,1,0-1.06-.11l-.408,4a.533.533,0,0,0,.475.585",
  transform: "translate(-221.149 0)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2405",
  "data-name": "Path 2405",
  d: "M280.106,55.867a.536.536,0,0,0-.74-.152l-3.712,2.436a.533.533,0,0,0,.3.978.541.541,0,0,0,.3-.085l3.712-2.436a.533.533,0,0,0,.131-.74",
  transform: "translate(-255.539 -51.613)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2406",
  "data-name": "Path 2406",
  d: "M292.569,138.991l-4.318-.777a.534.534,0,0,0-.189,1.051l4.315.777h.094a.533.533,0,0,0,.095-1.06Z",
  transform: "translate(-266.866 -128.232)",
  fill: "#707070"
}));
function SvgIconfeatherSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2705",
    "data-name": "Group 2705",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.154,
    height: 27.616,
    viewBox: "0 0 26.154 27.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherSpeaker);
export default __webpack_public_path__ + "static/media/Icon feather-speaker.34500e6a.svg";
export { ForwardRef as ReactComponent };